module.exports = __webpack_public_path__ + "img/demonstration.2e1b0e06.png";